import React from 'react';

const ImageMarquee = ({ 
  images, 
  speed = 35, 
  direction = 'left', 
  className = '',
  grayscale = true,
  gap = 'gap-4'
}) => {
  // Default editorial images
  const defaultImages = [
    'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=500&q=80',
    'https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=500&q=80',
    'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=500&q=80',
    'https://images.unsplash.com/photo-1511578314322-379afb476865?w=500&q=80',
    'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=500&q=80',
    'https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?w=500&q=80',
    'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=500&q=80',
    'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=500&q=80',
  ];

  const imageList = images || defaultImages;
  
  // Triple for seamless loop
  const duplicatedImages = [...imageList, ...imageList, ...imageList];

  return (
    <div 
      className={`overflow-hidden py-8 ${className}`}
      data-testid="image-marquee"
    >
      <div 
        className={`flex ${gap}`}
        style={{
          animation: `marquee-${direction} ${speed}s linear infinite`,
          width: 'max-content'
        }}
      >
        {duplicatedImages.map((img, index) => (
          <div 
            key={index}
            className="flex-shrink-0 w-56 h-72 md:w-72 md:h-96 lg:w-80 lg:h-[28rem] overflow-hidden rounded-lg group"
          >
            <img 
              src={img} 
              alt={`Gallery ${(index % imageList.length) + 1}`}
              className={`w-full h-full object-cover transition-all duration-700 group-hover:scale-105 ${
                grayscale ? 'grayscale hover:grayscale-0' : ''
              }`}
              loading="lazy"
            />
          </div>
        ))}
      </div>
      
      <style jsx="true">{`
        @keyframes marquee-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
        @keyframes marquee-right {
          0% { transform: translateX(-33.33%); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </div>
  );
};

export default ImageMarquee;
